import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

const AuthErrorPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message') || 'Ein unbekannter Fehler ist aufgetreten';

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md text-center space-y-6">
        <div className="space-y-4">
          <AlertTriangle className="h-16 w-16 mx-auto text-destructive" />
          <h2 className="text-2xl font-bold text-destructive">Anmeldung fehlgeschlagen</h2>
          <p className="text-muted-foreground">
            {message}
          </p>
        </div>

        <div className="space-y-4">
          <Button asChild className="w-full">
            <Link to="/login">
              Erneut versuchen
            </Link>
          </Button>
          
          <p className="text-sm text-muted-foreground">
            Falls das Problem weiterhin besteht, wenden Sie sich an Ihren Administrator.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthErrorPage;
